import { Platform } from '../types/platforms';

export const isMobilePlatform = (platform: Platform) => {
	return (
		platform === Platform.ANDROID || platform === Platform.IOS || platform === Platform.MOBILE
	);
};
